//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'AbsoluteNeutrophilCount',
  data() {
    return {
      defaultJson:{
        "Mild neutropenia": "轻度中性粒细胞减少",
        "Moderate neutropenia": "中度中性粒细胞减少",
        "ANC": "中性粒细胞计数",
        "Bands": "杆状核中性粒细胞",
        "Polys": "分叶核中性粒细胞",
        "WBC Count": "WBC 计数",
        "Severe neutropenia": "重度中性粒细胞减少"
      },
      form:{
        wbc:'',
        polys:'',
        bands:'',

      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
      pAo2:'...',
      aaGradient:'...',
      aaRatio:'...',
    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {  
        // 	wbc*(polys+bands)/100
        let result = (form.wbc*(form.polys+form.bands)/100).toFixed(0)
        
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/AbsoluteNeutrophilCount.vue